import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Divider from './components/divider';
import Store from './store';
import BackTopFooter from '@src/business-components/backtop-footer';
import redirect from '@src/utils/redirect-if-mobile-accress';

// PC端页面，如果是移动端访问，跳转到移动端页面
redirect.redirectIfMobile();

const styles = require('./index.less');

const Gameplay = ({ store }) => {
  store.use();

  const swiper = () => {
    return (
      <div className={styles.swiper}>
        <BaseSwiper key={store.slidesData.length} store={store.swiperStore}>
          {store.slidesData.map((item, index) => {
            return (
              <div key={index} className={styles.slide} style={{ backgroundImage: `url(${item?.gameplay_cover})` }}>
                <div className={styles.info}>
                  {/* 标题 */}
                  <div className={styles.title}>{item?.gameplay_title}</div>
                  {/* 分割线 */}
                  <Divider key={store.swiperStore.activeIndex} />
                  {/* 描述 */}
                  <div className={styles.desc}>{item?.gameplay_description}</div>
                </div>
              </div>
            );
          })}
        </BaseSwiper>
      </div>
    );
  };

  return (
    <Page className={cx(styles.root, 'page-main')}>
      <div className={styles.content}>
        {/* 轮播 */}
        {swiper()}
        {/* 轮播指示器 */}
        <div className={styles.indicator}>
          {store.slidesData?.map((item, index) => {
            return (
              <div
                key={index}
                className={cx(styles.indicatorItem, index === store.swiperStore.activeIndex && styles.indicatorActive)}
                onClick={() => {
                  store.swiperStore.onChange(index);
                }}
              >
                <div className={styles.indicatorInner}>
                  <div className={styles.indicatorBorder} />
                  <div className={styles.indicatorImgWrapper}>
                    <div>
                      <img
                        style={{ visibility: item?.gameplay_cover ? 'visible' : 'hidden' }}
                        src={item?.gameplay_cover}
                        className={styles.indicatorImg}
                        alt={item?.gameplay_title}
                      />
                    </div>
                  </div>
                  <span className={styles.indicatorType}>{item.gameplay_type}</span>
                  <div className={styles.indicatorTitle}>{item?.gameplay_title}</div>
                </div>
              </div>
            );
          })}
        </div>
        <BackTopFooter btns={['copyright']} />
      </div>
    </Page>
  );
};

export default wrapStore(Gameplay, Store);
